import { render, staticRenderFns } from "./ForeignInvestmentDetailsSection.vue?vue&type=template&id=590cb23c"
import script from "./ForeignInvestmentDetailsSection.vue?vue&type=script&lang=js"
export * from "./ForeignInvestmentDetailsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports